import App from 'app/app.js';
import 'app/constant/FailureTypeConstants.js';

function FailureMessageCtrl(
  $scope,
  $uibModalInstance,
  $filter,
  RouterService,
  FailureTypeConstants,
  failureType,
  ContentStore
) {
  this.failureType = failureType || FailureTypeConstants.UNKNOWN_FAILURE;
  this.disableSubmitButton = false;

  switch (this.failureType) {
    case FailureTypeConstants.INVALID_CARD_DETAILS:
    case FailureTypeConstants.INVALID_CARD_NUMBER:
    case FailureTypeConstants.CUSTOMER_ISSUE:
    case FailureTypeConstants.UNKNOWN_FAILURE:
    case FailureTypeConstants.PROCESSING_TIMEOUT:
    case FailureTypeConstants.UNSUPPORTED_CARD_TYPE:
      $scope.buttonText = $filter('ltTranslateFilter')('ERROR_BACK_TO_PAYMENT_DETAILS', {});
      break;
    case FailureTypeConstants.INVALID_BILLING:
    case FailureTypeConstants.FALLBACK_FAILURE:
      $scope.buttonText = $filter('ltTranslateFilter')('ERROR_BACK_TO_BILLING_DETAILS', {});
      break;
    case FailureTypeConstants.DUPLICATE_TRANSACTION:
      $scope.buttonText = $filter('ltTranslateFilter')('ERROR_BACK_TO_ORDER_REVIEW', {});
  }

  this.getFailureType = function () {
    return this.failureType;
  };

  this.goToNextPage = function () {
    switch (this.failureType) {
      case FailureTypeConstants.INVALID_CARD_DETAILS:
      case FailureTypeConstants.INVALID_CARD_NUMBER:
      case FailureTypeConstants.CUSTOMER_ISSUE:
      case FailureTypeConstants.UNKNOWN_FAILURE:
      case FailureTypeConstants.PROCESSING_TIMEOUT:
        this.closeModal();
        return RouterService.goToPaymentInfo();
      case FailureTypeConstants.INVALID_BILLING:
      case FailureTypeConstants.FALLBACK_FAILURE:
        this.closeModal();
        return RouterService.goToBillingInfo();
      case FailureTypeConstants.DUPLICATE_TRANSACTION:
      case FailureTypeConstants.UNSUPPORTED_CARD_TYPE:
        this.disableSubmitButton = true;
        this.closeModal();
    }
  };

  this.getImgSrc = function () {
    if (this.failureType === FailureTypeConstants.UNSUPPORTED_CARD_TYPE) {
      return ContentStore.getContentImageUrl('MOBILE_TRANS_REVIEW_ORDER', 'UNSUPPORTED_CARD_TYPE_IMAGE');
    }
  };

  this.closeModal = function () {
    $uibModalInstance.close(this.disableSubmitButton);
  };
}

App.controller('FailureMessageCtrl', [
  '$scope',
  '$uibModalInstance',
  '$filter',
  'RouterService',
  'FailureTypeConstants',
  'failureType',
  'ContentStore',
  FailureMessageCtrl
]);
